import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { UUID } from '../../../../../../types/shared/UUID';
import { clientUrls } from '../../../../../../ui-toolkit/rest/ClientUrlFactory';
import { BanknotesIcon } from '@heroicons/react/24/outline';
import { SECTION_L_DEFINITION_ID } from './constants';

export const NoEmdFee: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();

  return (
    <div className={'flex flex-col gap-2 py-2'}>
      <p className="text-sm font-bold leading-normal text-gray-600">No applicable fees</p>
      <p className="text-base font-normal leading-normal text-neutral-900">Create a fee to send an access code.</p>
      <Link
        to={clientUrls.urlFor.feesTabEdit(orderId, 'k-n', SECTION_L_DEFINITION_ID)}
        className="flex w-40 items-start justify-start gap-2 rounded-2xl border border-emerald-900 bg-white px-3 py-1.5"
      >
        <div className="inline-flex flex-col items-center justify-start gap-2 p-1">
          <BanknotesIcon className="h-4 w-4 text-center text-base font-black leading-tight text-emerald-900" />
        </div>
        <p className="text-center text-sm font-bold leading-normal text-emerald-900">Create a fee</p>
      </Link>
    </div>
  );
};
